import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_pedido_compra_detalhe_pagamento_parcelado = _resolveComponent("pedido-compra-detalhe-pagamento-parcelado")!
  const _component_pedido_compra_detalhe_pagamento_outros = _resolveComponent("pedido-compra-detalhe-pagamento-outros")!
  const _component_requisitar_autorizacao_modal = _resolveComponent("requisitar-autorizacao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 700,
    centered: "",
    "wrap-class-name": 'ss-modal-vendas ' + (_ctx.state.telaMobile ? 'full-modal' : '')
  }, {
    title: _withCtx(() => [
      _createTextVNode("Detalhe de Pagamento")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Tipo de Documento",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_selecionar_tipo_documento_financeiro, {
                    key: _ctx.state.tiposDocumentosDisponiveis.length,
                    tiposDocumentosEspecificos: _ctx.state.tiposDocumentosDisponiveis,
                    empresas: [_ctx.props.pedidoCompra.codigoEmpresa],
                    codigoSelecionado: _ctx.state.detalhePagamento.tipoDocumento,
                    "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.detalhePagamento.tipoDocumento) = $event)),
                    descricaoSelecionado: _ctx.state.detalhePagamento.descricaoTipoDocumento,
                    "onUpdate:descricaoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.detalhePagamento.descricaoTipoDocumento) = $event)),
                    onChange: _ctx.alterarTipoDocumento,
                    disabled: _ctx.state.detalhePagamento.alterado || _ctx.UtilitarioGeral.validaCodigo(_ctx.state.detalhePagamento.codigo)
                  }, null, 8, ["tiposDocumentosEspecificos", "empresas", "codigoSelecionado", "descricaoSelecionado", "onChange", "disabled"]))
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.state.detalhePagamento.tipoDocumento !== undefined && _ctx.state.detalhePagamento.tipoDocumento !== 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.state.tipoDocumentoSelecionado.gerarCarteira && _ctx.state.detalhePagamento.alterado === false && !_ctx.UtilitarioGeral.validaCodigo(_ctx.state.detalhePagamento.codigo))
                  ? (_openBlock(), _createBlock(_component_pedido_compra_detalhe_pagamento_parcelado, {
                      key: 0,
                      parcelas: _ctx.state.parcelasDisponiveis,
                      valorRestante: _ctx.state.valorRestante,
                      qtdParcelas: _ctx.state.qtdParcelasSelecionada,
                      "onUpdate:qtdParcelas": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.qtdParcelasSelecionada) = $event)),
                      valorParcelado: _ctx.state.valorParcelado,
                      "onUpdate:valorParcelado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.valorParcelado) = $event)),
                      empresa: _ctx.props.pedidoCompra.codigoEmpresa,
                      codigoPlanoConta: _ctx.state.codigoPlanoConta,
                      "onUpdate:codigoPlanoConta": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.codigoPlanoConta) = $event)),
                      nomePlanoConta: _ctx.state.nomePlanoConta,
                      "onUpdate:nomePlanoConta": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.nomePlanoConta) = $event))
                    }, null, 8, ["parcelas", "valorRestante", "qtdParcelas", "valorParcelado", "empresa", "codigoPlanoConta", "nomePlanoConta"]))
                  : (_openBlock(), _createBlock(_component_pedido_compra_detalhe_pagamento_outros, {
                      key: 1,
                      empresa: _ctx.props.pedidoCompra.codigoEmpresa,
                      "detalhe-pagamento": _ctx.state.detalhePagamento,
                      "onUpdate:detalhePagamento": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.detalhePagamento) = $event)),
                      editavel: _ctx.props.editavel
                    }, null, 8, ["empresa", "detalhe-pagamento", "editavel"]))
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_requisitar_autorizacao_modal, {
            visivel: _ctx.requisicaoAutorizacaoBase.exibirRequisicao,
            "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requisicaoAutorizacaoBase.exibirRequisicao) = $event)),
            "identificador-permissao": _ctx.requisicaoAutorizacaoBase.permissao,
            descricao: _ctx.requisicaoAutorizacaoBase.descricao,
            onAutorizada: _ctx.salvar
          }, null, 8, ["visivel", "identificador-permissao", "descricao", "onAutorizada"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}